<template>
  <label class="check-box">
    <input type="checkbox" :checked="checkedState" @click="onCheckBoxClick" />
    <span></span>
  </label>
</template>

<script>
export default {
  name: `BaseCheckBox`,
  props: ['id', 'selected'],
  computed: {
      checkedState() {
          return this.selected.includes(this.id)
      }
  },
  methods: {
      onCheckBoxClick() {
        this.$emit('on-check-box-click', this.id)
      }
  }
};
</script>

<style lang="scss" scoped>
.check-box {
  display: inline-flex;
  cursor: pointer;
  position: relative;
  input {
      margin: 0;
      border: .0625em solid #d7d7d7;
  }
}

.check-box > input {
  height: 1.5625em;
  width: 1.5625em;
  appearance: none;
  border-radius: 0.25em;
  outline: none;
  transition-duration: 0.3s;
  cursor: pointer;
}

.check-box > input:checked {
  background-color: #08ce97;
}

.check-box > input:checked + span::before {
  display: flex;
  justify-content: center;
  align-items: center;
  content: "\2713";
  color: #fff;
  font-size: 1.25em;
  font-weight: 600;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}
</style>
